import React from "react";
import {
  HeroTextWrapper,
  Header,
  OuterHeroTextWrapper,
  CurvedHeroTextWrapper,
  HeaderH2,
} from "./Hero.styles";
import {Ingress} from "BaseComponents/Text";
import {ColoredButton, ButtonText as BtnText} from "BaseComponents/Button";
import {getButtonColor} from "Helpers/ColorHelper";

export const HeroText = ({
                           Heading,
                           UseFontMarydale,
                           Preamble,
                           ShowButton,
                           ButtonLink,
                           ButtonTarget,
                           ButtonText,
                           ButtonColor,
                           HeroCurvedTextArea,
                           BackgroundColor,
                           HeaderMaxWidth = '500px',
                           CurvedHeaderMaxWidth = '450px',
                           hasSlider = false,
                           isVideo = false,
                           showHero = false,
                           firstVideo = false
                         }) => {
  const {color, textColor} = getButtonColor(ButtonColor);
  let bgInnerColor, bgInnerTextColor = undefined;
  if (BackgroundColor) {
    const {color: bgColor, textColor: bgTextColor} = getButtonColor(BackgroundColor);
    bgInnerColor = bgColor;
    bgInnerTextColor = bgTextColor;
  }

  return (
    <>
      {HeroCurvedTextArea ? (
        <>
          <OuterHeroTextWrapper
            {...{showBlock: Heading || Preamble || ButtonLink}}
            heroCurvedTextArea={HeroCurvedTextArea}
            hasSlider={hasSlider}
            isVideo={isVideo}
          >
            <HeroTextWrapper
              height="100%"
              padding={HeroCurvedTextArea ? "0 3rem 0 1rem" : "1rem 0"}
              backgroundColor={bgInnerColor ? bgInnerColor :
                HeroCurvedTextArea
                  ? "rgba(255, 255, 255, 0.9)"
                  : "rgba(247, 247, 247, 0.9)"
              }
              largeMaxWidth={HeroCurvedTextArea ? "100%" : "60%"}
              heroCurvedTextArea={HeroCurvedTextArea}
              CurvedHeaderMaxWidth={CurvedHeaderMaxWidth}
            ></HeroTextWrapper>
          </OuterHeroTextWrapper>
          <CurvedHeroTextWrapper column align="flex-start" CurvedHeaderMaxWidth={CurvedHeaderMaxWidth}>
            {isVideo && Heading && (!firstVideo ? <HeaderH2
              className={`${UseFontMarydale ? "marydale" : ""}`}
              maxWidth={HeaderMaxWidth}
              lineHeight="56px"
              fontSize={"50px"}
              color={bgInnerTextColor ? bgInnerTextColor : 'black'}
            >
              {Heading}
            </HeaderH2> : <Header
              className={`${UseFontMarydale ? "marydale" : ""}`}
              maxWidth={HeaderMaxWidth}
              lineHeight="56px"
              fontSize={"50px"}
              color={bgInnerTextColor ? bgInnerTextColor : 'black'}
            >
              {Heading}
            </Header>)}
            {!isVideo && Heading && (!showHero ? <Header
                className={`${UseFontMarydale ? "marydale" : ""}`}
                maxWidth={HeaderMaxWidth}
                lineHeight="56px"
                fontSize={"50px"}
                color={bgInnerTextColor ? bgInnerTextColor : 'black'}
              >
                {Heading}
              </Header> :
              <Header
                className={`${UseFontMarydale ? "marydale" : ""}`}
                maxWidth={HeaderMaxWidth}
                lineHeight="56px"
                color={bgInnerTextColor ? bgInnerTextColor : 'black'}
              >
                {Heading}
              </Header>)
            }
            {Preamble && (
              <Ingress
                margin="0.5rem 0"
                marginSmall="0.5rem 0 0.5rem 0"
                maxWidth={HeaderMaxWidth}
                color={bgInnerTextColor ? bgInnerTextColor : 'black'}
              >
                {Preamble}
              </Ingress>
            )}
            {ShowButton && (
              <ColoredButton
                href={ButtonLink}
                inverted
                bgColor={color}
                minWidth="180px"
                width="fit-content"
                color={textColor}
                margin="1.5rem 0 0 0"
                smallmargin="1.5rem 0 0 0"
                padding={
                  currentTheme === "norlandiacare"
                    ? "0.47rem 3.75rem"
                    : "0.1rem 1rem"
                }
                target={ButtonTarget}
                aria-label={ButtonText}
              >
                <BtnText color={textColor} heading={Heading || ''}>{ButtonText}</BtnText>
              </ColoredButton>
            )}
          </CurvedHeroTextWrapper>
        </>
      ) : (
        <OuterHeroTextWrapper
          {...{showBlock: Heading || Preamble || ButtonLink}}
          heroCurvedTextArea={HeroCurvedTextArea}
          isVideo={isVideo}
        >
          <HeroTextWrapper
            CurvedHeaderMaxWidth={CurvedHeaderMaxWidth}
            height="100%"
            padding={HeroCurvedTextArea ? "0 3rem 0 1rem" : "1rem 0"}
            backgroundColor={bgInnerColor ? bgInnerColor :
              HeroCurvedTextArea
                ? "rgba(255, 255, 255, 0.9)"
                : "rgba(247, 247, 247, 0.9)"
            }
            largeMaxWidth={HeroCurvedTextArea ? "100%" : "60%"}
            heroCurvedTextArea={HeroCurvedTextArea}
          >
            <HeroTextWrapper column align="flex-start" CurvedHeaderMaxWidth={CurvedHeaderMaxWidth}>
              {isVideo && Heading && (!firstVideo ? <HeaderH2
                className={`${UseFontMarydale ? "marydale" : ""}`}
                maxWidth={HeaderMaxWidth}
                lineHeight="56px"
                fontSize={"50px"}
                color={bgInnerTextColor ? bgInnerTextColor : 'black'}
              >
                {Heading}
              </HeaderH2> : <Header
                className={`${UseFontMarydale ? "marydale" : ""}`}
                maxWidth={HeaderMaxWidth}
                lineHeight="56px"
                fontSize={"50px"}
                color={bgInnerTextColor ? bgInnerTextColor : 'black'}
              >
                {Heading}
              </Header>)}
              {!isVideo && Heading && (!showHero ? <Header
                  className={`${UseFontMarydale ? "marydale" : ""}`}
                  maxWidth={HeaderMaxWidth}
                  lineHeight="56px"
                  fontSize={"50px"}
                  color={bgInnerTextColor ? bgInnerTextColor : 'black'}
                >
                  {Heading}
                </Header> :
                <Header
                  className={`${UseFontMarydale ? "marydale" : ""}`}
                  maxWidth={HeaderMaxWidth}
                  lineHeight="56px"
                  color={bgInnerTextColor ? bgInnerTextColor : 'black'}
                >
                  {Heading}
                </Header>)
              }
              {Preamble && (
                <Ingress
                  margin="0.5rem 0"
                  marginSmall="0.5rem 0 0.5rem 0"
                  color={bgInnerTextColor ? bgInnerTextColor : 'black'}
                  maxWidth={HeaderMaxWidth}
                >
                  {Preamble}
                </Ingress>
              )}
              {ShowButton && (
                <ColoredButton
                  href={ButtonLink}
                  inverted
                  bgColor={color}
                  minWidth="180px"
                  width="fit-content"
                  color={textColor}
                  margin="1.5rem 0 0 0"
                  smallmargin="1.5rem 0 0 0"
                  padding={
                    currentTheme === "norlandiacare"
                      ? "0.47rem 3.75rem"
                      : "0.1rem 1rem"
                  }
                  target={ButtonTarget}
                  aria-label={ButtonText}
                >
                  <BtnText color={textColor} heading={Heading || ''}>{ButtonText}</BtnText>
                </ColoredButton>
              )}
            </HeroTextWrapper>
          </HeroTextWrapper>
        </OuterHeroTextWrapper>
      )}
    </>
  );
};

HeroText.propTypes = {};
